import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { Grid, Typography } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";

const SectionSelector = ({ sections }) => {
    const [selectedSection, setSelectedSection] = useState(0);

    const color = useSelector(getAppColor);
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const sectionParam = searchParams.get("section");
        if (sectionParam !== null) {
            const index = parseInt(sectionParam, 10);
            if (!isNaN(index) && index >= 0 && index < sections.length) {
                setSelectedSection(index);
            }
        }
    }, [location.search, sections.length]);

    const handleSelectSection = (key) => {
        setSelectedSection(key);
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("section", key);
        history.replace({ search: searchParams.toString() });
    };
    return (
        <>
            <Grid container direction="row" item xs={12}>
                {sections.map((section) => {
                    return (
                        <Grid key={section.key} container item xs={12} sm={6} md={4} justify="center">
                            <div
                                onClick={() => handleSelectSection(section.key)}
                                style={{
                                    cursor: "pointer",
                                    margin: 5,
                                    padding: "5px 20px",
                                    borderBottom:
                                        section.key === selectedSection ? `2px solid ${color}` : "transparent",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "flex-start",
                                    position: "relative",
                                }}
                            >
                                <Typography align="center" className="whiteText" style={{ fontSize: 18 }}>
                                    {section.title}
                                </Typography>
                                <Typography align="center" className="whiteText" style={{ fontSize: 12 }}>
                                    {section.subtitle}
                                </Typography>
                            </div>
                        </Grid>
                    );
                })}
            </Grid>
            {sections[selectedSection].content}
        </>
    );
};

export default SectionSelector;
